import React from 'react'
import OptionsMenu from '../../utils/OptionsMenu'
import './styles.css'
import QueuePage from './Pages/queue-page'
import UsersPage from './Pages/users-page'
import userPermissions from '../User/Permissions'
import IntegrationPage from './Pages/integration-page'
import { getSession } from '../../auth'
import OnChatPage from './Pages/onchat-page'
import PhonePage from './Pages/phone-page'
import ScoutPage from './Pages/scout-page'
import AuditPage from "./Pages/audit-page"
import AuthPage from "./Pages/auth-page"
import WhatsAppVoicePage from "./Pages/whatsapp-voice-page"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import KeyIcon from "@mui/icons-material/Key"
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions"
import PhoneIcon from "@mui/icons-material/Phone"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import ScoutLogo from "../../assets/images/kwik-scout-logo.png"
import { hasActivePlatforms } from "../../utils/utils"
import { useMenu } from "../../contexts/MenuContext"

const options = () => {
    const { configurableUrls } = useMenu()
    
    const groups = userPermissions();
    
    return {
        onchat: {
            permissions: groups.isAdmin,
            label: 'Atendimento',
            component: (<OnChatPage />),

            isAvailable: hasActivePlatforms(getSession().profile?.enterprise?.platforms || {}),
            unavailable: {
                icon: <SupportAgentIcon />,
                title: "Recurso indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.atendimento ? configurableUrls.atendimento : "https://solucoes.instant.com.br/kwik/"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de atendimento, clique aqui.
                    </a>
                ),
            }
        },
        audit: {
            permissions: groups.isAdmin,
            label: "Auditoria",
            component: (<AuditPage />),
            isAvailable: true,
        },
        auth: {
            permissions: groups.isAdmin,
            label: "Autenticação 2FA",
            component: (<AuthPage />),

            isAvailable: getSession().profile?.enterprise?.has_2fa_auth,
            unavailable: {
                icon: <KeyIcon />,
                title: "Recurso indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar a autenticação 2FA, clique aqui.
                    </a>
                ),
            }
        },
        queues: {
            permissions: groups.isSupervisor,
            label: 'Filas',
            component: (<QueuePage />),

            isAvailable: hasActivePlatforms(getSession().profile?.enterprise?.platforms || {}),
            unavailable: {
                icon: <SupportAgentIcon />,
                title: "Recurso indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.atendimento ? configurableUrls.atendimento : "https://solucoes.instant.com.br/kwik/"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de atendimento, clique aqui.
                    </a>
                ),
            }
        },
        integrations: {
            permissions: groups.isAdmin,
            label: 'Integrações',
            component: (<IntegrationPage />),

            isAvailable: getSession().profile?.enterprise?.integration,
            unavailable: {
                icon: <IntegrationInstructionsIcon />,
                title: "Recurso indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.integracoes ? configurableUrls.integracoes : "https://solucoes.instant.com.br/kwik/#integracoes"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de integrações, clique aqui.
                    </a>
                ),
            }
        },
        scout: {
            permissions: groups.isAdmin,
            label: 'Scout',
            component: (<ScoutPage />),

            isAvailable: getSession().profile?.enterprise?.platforms?.scout && getSession().profile?.scout,
            unavailable: {
                icon: <img src={ScoutLogo} alt="Kwik Scout" style={{ width: 350 }} />,
                title: getSession().profile?.enterprise?.platforms?.scout !== true
                    ? "Recurso indisponível para sua conta."
                    : "Recurso indisponível para seu usuário.",
                description: getSession().profile?.enterprise?.platforms?.scout !== true
                    ? (
                        <a
                            href={configurableUrls?.scout ? configurableUrls.scout : "https://scout.kwik.app.br/"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Para mais informações sobre o Kwik Scout, clique aqui.
                        </a>
                    )
                    : (
                        <span>
                            Entre em contato com seu administrador para ativar.
                        </span>
                    )
            }
        },
        phone: {
            permissions: groups.isAdmin,
            label: 'Telefonia',
            component: (<PhonePage />),

            isAvailable: getSession().profile?.enterprise?.has_voice,
            unavailable: {
                icon: <PhoneIcon />,
                title: "Recurso indisponível para sua conta.",
                description: (
                  <a href={configurableUrls?.telefonia ? configurableUrls.telefonia : "https://landing.instant.com.br/instant-cloud-voice/"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de telefonia, clique aqui.
                    </a>
                )
            }
        },
        whatsapp_voice: {
            permissions: groups.isAdmin,
            label: 'Telefonia WhatsApp',
            component: (<WhatsAppVoicePage />),

            isAvailable: getSession().profile?.enterprise?.whatsapp_calling,
            unavailable: {
                icon: <WhatsAppIcon sx={{ color: '#34af23' }} />,
                title: "Recurso indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o módulo de telefonia WhatsApp, clique aqui.
                    </a>
                )
            }
        },
        users: {
            permissions: groups.isSupervisor,
            label: 'Usuários',
            component: (<UsersPage />),
            isAvailable: true
        },
    }
}

const SettingsV2 = () => {
    return (
        <OptionsMenu title='Configurações' name='settings-v2' options={options} />
    )
}


export default SettingsV2